import type { OfferDecision } from "./providers";

/**
 * Wave 4c T5 — the decision trace every `affiliate_impression` and
 * `affiliate_click` carries, so any click can be traced back to why that ad
 * was shown to that visitor. One mapping shared by every affiliate surface
 * (OfferCard, the sticky bar, the Hunt card) so the property names cannot
 * drift between them.
 *
 * `decision` is the targeting decision (exploit | explore | fatigue_rotate |
 * lock_exploit | fallback_global). The Wave 4b copy-bandit branch moved to
 * `copy_decision` — it shipped dark (`copyGeneration.enabled: false`), so no
 * production event ever carried it under the old name.
 *
 * Undefined values are dropped by PostHog, so a render with targeting off
 * carries only `rank_position` / `sampled_score` / `variant_id`.
 */
export function decisionTraceProps(decision: OfferDecision | undefined): {
	context_key?: string;
	backoff_level?: number;
	decision?: string;
	targeting_group?: string;
	p_best?: number;
	sampled_score?: number;
	rank_position?: number;
	variant_id?: string;
	copy_decision?: string;
} {
	if (!decision) return {};
	return {
		context_key: decision.contextKey,
		backoff_level: decision.backoffLevel,
		decision: decision.targetingDecision,
		targeting_group: decision.targetingGroup,
		p_best: decision.pBest,
		sampled_score: decision.sampledScore,
		rank_position: decision.rankPosition,
		variant_id: decision.variantId,
		copy_decision: decision.copyDecision,
	};
}
